import { toast } from "react-toastify";
import { base_url, endpoints } from "../../Api/configs";
import { getLoginData } from "../AppStoreData";
import { parseResponseBody } from "../../services/apiClient";

export async function updateHelpTicketAPI(ticketId: string) {
  const data = await getLoginData();
  const url = `${base_url}${endpoints.help.updateHelpTickets}`;
  const bodyParams = {
    ticketId,
    accessToken: data.AccessToken,
  };

  try {
    const res = await fetch(url, {
      mode: "cors",
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ body: bodyParams }),
    });

    let response = await res.json();
    response = parseResponseBody(response);

    if (res.status === 200 && response.statusCode === 200) {
      return response.body;
    } else {
      toast.error(response.body.error);
    }
  } catch (error) {
    toast.error(error.message);
  }
}
